import { cx } from '@linaria/core';
import { mdiCrown } from '@mdi/js';
import Icon from '@mdi/react';
import { locales } from '../../locales/en';
import "./Crown.linaria.module.css!=!./Crown?./Crown.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNTy+Mz0wpSEs30UPhVecmFqVn5ukm5ZeU5OdaGVjXcgEAa7kIUi8AAAA="
const bottomMargin = "atm_gq_idpfg4";
const Crown = props => <Icon path={mdiCrown} title={locales.settings.pinToTop.priorWinnersTooltip} size={0.8} {...props} className={cx(bottomMargin, props.className)} />;
export default Crown;